import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CouponapiService } from './couponapi.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrlVegitation}api/`;

@Injectable({
  providedIn: 'root'
})
export class AddcouponService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  excelContent: any;

  constructor(private apiService: CouponapiService, private http: HttpClient) {

  }

  createNewCouponData(body?: any): Observable<any> {
    return this.apiService.post(APIs.createNewCoupon, body).pipe(map(response => {
      return response;
    }));
  }

  updateNewCouponData(body?: any): Observable<any> {
    return this.apiService.post(APIs.updateNewCoupon, body).pipe(map(response => {
      return response;
    }));
  }
}